import joinDefinedStringParts from "@utils/joinDefinedStringParts";

import loadStreetData from "./loadStreetData";
import loadStreetSuggestions from "./loadStreetSuggestions";

type TLoadZipCodeArgs = Record<"city" | "country" | "street" | "houseNumber", string | undefined> & {
  defaultLocale: string;
};

const loadZipCode = async ({
  defaultLocale,
  city,
  country,
  street,
  houseNumber,
}: TLoadZipCodeArgs): Promise<{
  data?: string;
  error?: string | undefined;
}> => {
  try {
    const streetAddress = joinDefinedStringParts([street, houseNumber], " ");

    const suggestionsResponse = await loadStreetSuggestions({
      defaultLocale,
      country: country || defaultLocale!,
      streetQuery: joinDefinedStringParts([streetAddress, city], ", "),
    });

    if (suggestionsResponse.error) {
      return { error: suggestionsResponse.error };
    }

    const addressId = suggestionsResponse.data[0]?.id;
    if (!addressId) {
      throw new Error("Error: no address id!");
    }

    const dataResponse = await loadStreetData({ defaultLocale, id: addressId });
    if (dataResponse.error) {
      return { error: dataResponse.error };
    }
    const postalCode = dataResponse.data?.postalCode;
    if (!postalCode) {
      throw new Error("Error: no postal code!");
    }
    return { data: postalCode };
  } catch (err) {
    console.error(err);
    return { data: undefined, error: undefined };
  }
};

export default loadZipCode;
